import CurrencyIcon from '@/component/CurrencyIcon'
import Price from '@/component/Price'
import TGASDK from '@/config/TGASDK'
import { Wallet } from '@kulee/tga-sdk'
import type { ChargeCommodity } from '@kulee/tga-sdk/types/types/wallet'
import React, { useEffect } from 'react'
import { twMerge } from 'tailwind-merge'

const DiamondCommodityItem: React.FC<PropType> = ({ item, actived = false, onSelect }) => {
  const { price, quantity, freeQuantity, prefix, paymentCurrencyCode } = item

  const handleClick = async () => {
    onSelect && onSelect(item)
  }

  useEffect(() => {
    TGASDK.addModule(Wallet)
  }, [])

  const classNames = twMerge(
    'cursor-pointer rounded-lg text-center relative overflow-hidden py-sm pt-3 bg-primary/20 border border-primary/0 hover:bg-primary/30',
    actived && 'bg-primary/50 border-semantic-success'
  )

  return (
    <div className={classNames} onClick={handleClick}>
      <div className="flex items-center justify-center gap-[2px]">
        <CurrencyIcon code="diamond" size="small" />
        <span className="text-lg font-custom-bold">{quantity + freeQuantity}</span>
      </div>
      <Price
        size="small"
        currencyCode={paymentCurrencyCode}
        currencyPrefix={prefix}
        price={price}
        className="text-gray-500 font-medium"
      />
      {freeQuantity > 0 && (
        <div className="absolute top-0 right-0 bg-red-500 text-white px-2 rounded-bl-lg text-xs">+{freeQuantity}</div>
      )}
    </div>
  )
}

interface PropType {
  item: ChargeCommodity
  actived?: boolean
  onSelect?: (item: ChargeCommodity) => void
}

export default DiamondCommodityItem
